import defaultTheme from 'tailwindcss/defaultTheme';
const fonts = {
    fontSize: {
        ...defaultTheme.fontSize,
        xxxs: ['.5rem', {
                lineHeight: '0.625rem'
            }],
        xxs: ['.625rem', {
                lineHeight: '0.75rem'
            }],
        // xs: ['0.75rem', { lineHeight: '1rem' }], // 12px - 16px DEFAULT
        // sm: ['0.875rem', { lineHeight: '1.25rem' }], // 14px - 20px DEFAULT
        // base: ['1rem', { lineHeight: '1.5rem' }], // 16px - 24px DEFAULT
        // lg: ['1.125rem', { lineHeight: '1.75rem' }], // 18px - 28px DEFAULT
        // xl: ['1.25rem', { lineHeight: '1.75rem' }], // 20px - 28px DEFAULT
        // 2xl: ['1.5rem', { lineHeight: '2rem' }], // 24px - 32px DEFAULT
        '2.5xl': ['1.6875rem', {
                lineHeight: '2.125rem'
            }]
        // 3xl: ['1.875rem', { lineHeight: '2.25rem' }], // 30px - 36px DEFAULT
        // 4xl: ['2.25rem', { lineHeight: '2.5rem' }], // 36px - 40px DEFAULT
        // 5xl: ['3rem', { lineHeight: '1' }], // 48px DEFAULT
        // 6xl: ['3.75rem', { lineHeight: '1' }], // 60px DEFAULT
        // 7xl: ['4.5rem', { lineHeight: '1' }], // 72px DEFAULT
        // 8xl: ['6rem', { lineHeight: '1' }], // 96px DEFAULT
        // 9xl: ['8rem', { lineHeight: '1' }], // 128px DEFAULT
    },
    lineHeight: {
        ...defaultTheme.lineHeight,
        7.5: '1.875rem'
    }
};
export default fonts;
